import { useSelector } from 'react-redux';
import { Divider, Label } from '@vinted/web-ui';
import SeparatedList from 'components/SeparatedList';
import useTracking from 'hooks/useTracking';
import useTranslate from 'hooks/useTranslate';
import { ADVERTISING_URL, JOBS_URL, JOBS_URL_NEW, MAIN_NAVIGATION_ABOUT_TAB_URL, PRESS_URL } from 'constants/routes';
import { ClickableElement } from 'constants/tracking/clickable-elements';
import { clickEvent } from 'libs/common/event-tracker/events';
import { getPressCenterUrl, getSustainabilityUrl } from 'libs/utils/press-center';
import { getIsFeatureSwitchEnabled } from 'state/feature-switches/selectors';
import { getLocale } from 'state/intl/selectors';
import OtherLink from '../OtherLink';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

const Company = () => {
  const translate = useTranslate('header.main_navigation.about.company');
  const locale = useSelector(getLocale);
  const {
    track
  } = useTracking();
  const isSustainabilityPageEnabled = useSelector(getIsFeatureSwitchEnabled('sustainability_page_press_center_link'));
  const isPressMenuEnabled = useSelector(getIsFeatureSwitchEnabled('press_menu'));
  const isJobsPageEnabled = useSelector(getIsFeatureSwitchEnabled('jobs_page'));
  const isPressCenterLinkEnabled = useSelector(getIsFeatureSwitchEnabled('web_press_center_link'));
  const isNewJobsUrlEnabled = useSelector(getIsFeatureSwitchEnabled('new_jobs_career_portal'));
  const shortLocale = locale.substring(0, 2);
  const pressUrl = isPressCenterLinkEnabled ? getPressCenterUrl(shortLocale) : PRESS_URL;
  const jobsUrl = isNewJobsUrlEnabled ? JOBS_URL_NEW : JOBS_URL;

  const handleSustainabilityClick = () => {
    track(clickEvent({
      target: ClickableElement.SustainabilityPageLink,
      targetDetails: 'navigation_web'
    }));
  };

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Label, {
      styling: Label.Styling.Wide,
      text: translate('title')
    }), /*#__PURE__*/_jsxs(SeparatedList, {
      separator: /*#__PURE__*/_jsx(Divider, {}),
      children: [/*#__PURE__*/_jsx(OtherLink, {
        title: translate('items.about'),
        url: MAIN_NAVIGATION_ABOUT_TAB_URL
      }), isJobsPageEnabled && /*#__PURE__*/_jsx(OtherLink, {
        title: translate('items.jobs'),
        url: jobsUrl
      }), isSustainabilityPageEnabled && /*#__PURE__*/_jsx(OtherLink, {
        title: translate('items.sustainability'),
        url: getSustainabilityUrl(shortLocale),
        onClick: handleSustainabilityClick
      }), isPressMenuEnabled && /*#__PURE__*/_jsx(OtherLink, {
        title: translate('items.press'),
        url: pressUrl
      }), /*#__PURE__*/_jsx(OtherLink, {
        title: translate('items.advertising'),
        url: ADVERTISING_URL
      })]
    })]
  });
};

export default Company;